import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/login/login.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { EventsComponent } from './features/events/events.component';
import { JobsComponent } from './features/jobs/jobs.component';
import { PostsComponent } from './features/posts/posts.component';
import { VolunteerPageComponent } from './features/volunteer/volunteer-page/volunteer-page.component';
import { authGuard } from './core/guards/auth.guard';
import { EventManagerComponent } from './features/event-manager/base/event-manager.component';
import { StaffManagerComponent } from './features/staff-manager/staff-manager.component';
import { CheckoutManagerComponent } from './features/checkout-manager/checkout-manager.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard]
  },
  {
    path: 'events',
    component: EventsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'jobs',
    component: JobsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'posts',
    component: PostsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'volunteers',
    component: VolunteerPageComponent,
    canActivate: [authGuard]
  },  {
    path: 'event-manager',
    component: EventManagerComponent,
    canActivate: [authGuard]
  },
  {
    path: 'staff-manager',
    component: StaffManagerComponent,
    canActivate: [authGuard]
  },
  {
    path: 'checkout-manager',
    component: CheckoutManagerComponent,
    canActivate: [authGuard]
  },
  {
    path: 'relocate-manager',
    canActivate: [authGuard],
    loadComponent: () => import('./features/relocate-manager/relocate-manager.component').then(m => m.RelocateManagerComponent)
  },
  {
    path: 'contatos',
    canActivate: [authGuard],
    loadComponent: () => import('./features/contato-manager/contato-manager.component').then(m => m.ContatoManagerComponent)
  },
  {
    path: 'user-manager',
    canActivate: [authGuard],
    loadComponent: () => import('./features/user-manager/user-manager.component').then(m => m.UserManagerComponent)
  },
  {
    path: 'meu-local',
    canActivate: [authGuard],
    loadComponent: () => import('./features/meu-local/meu-local.component').then(m => m.MeuLocalComponent)
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' }
];
